import { useState } from 'react';

import { DatePickerWrapperStyles } from "./styles";

import 'react-datepicker/dist/react-datepicker.css'

import ptBR  from 'date-fns/locale/pt-BR';
import DatePicker from "react-datepicker";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import getDay from "date-fns/getDay";

import { DataInicioAgendamento } from "../../constants/dataInicioAgendamento"

export const Agendamento= ({ onChange } : any) => {

  let dataIncio = DataInicioAgendamento();

  const [startDate, setStartDate] = useState(() => {

    return DataInicioAgendamento();

  });

  const fimDeSemana = (date: Date) => {
    const day = getDay(date);

    return day !== 0 && day !== 6;
  };

  const horarioComercial = (time: Date) => {

    let currentDate = new Date();

    currentDate.setHours(currentDate.getHours() + 2);

    let selectedDate = new Date(time);

    return DataInicioAgendamento() < selectedDate && currentDate.getTime() < selectedDate.getTime() && (selectedDate.getHours() >= 8 && selectedDate.getHours() <= 17);
  };

  const handleAgendamentoUpdate = (date: Date) => {
    setStartDate(date);
    if(date !== null ){
        onChange(date);
    } else {
        onChange(null);
    }
  };

  return (
    <DatePickerWrapperStyles>
      <DatePicker
        locale={ptBR}
        selected={startDate}
        onChange={handleAgendamentoUpdate}
        minDate={dataIncio}
        showTimeSelect
        filterDate={fimDeSemana}
        filterTime={horarioComercial}
        excludeTimes={[
          setHours(setMinutes(new Date(), 0), 8),
          setHours(setMinutes(new Date(), 30), 17),
        ]}
        dateFormat="dd/MM/yyyy - HH:mm"
      />
    </DatePickerWrapperStyles>
  );
};